module.exports = __webpack_public_path__ + "static/media/rs.95f28ecc.svg";